import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";
import './SolicitacaoAdesaoArquivosGrandesVoumes.css';

import { SolicitacaoAdesaoArquivosGrandesVolumesDetails } from "./Details";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { SolicitacaoAdesaoAttachmentsAndHistory } from "./AttachmentsAndHistory";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const SolicitacaoAdesaoArquivosGrandesVolumesApproval =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				solicitacao: {
					numero: '',
					nomeSituacao: '',
					orgao: '',
					tituloConjuntoArquivo: '',
					nomeOrgaoConjuntoArquivo: '',
					descricaoConjuntoArquivo: '',
					arquivos: [],
					nomeDirigenteTi: '',
					nomeResponsavelTecnico: '',
					finalidade: '',
					justificativaOrgaoFornecedor: '',
					justificativaOrgaoAdministrador: '',
				},
				botoesHabilitados: true,
				exibeModalConfirmacao: false,
				msgModal: '',
				operacao: null,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.aprovarSolicitacao = this.aprovarSolicitacao.bind(this);
			this.rejeitarSolicitacaoOrgaoFornecedor = this.rejeitarSolicitacaoOrgaoFornecedor.bind(this);
			this.deferirSolicitacao = this.deferirSolicitacao.bind(this);
			this.rejeitarSolicitacaoAdministrador = this.rejeitarSolicitacaoAdministrador.bind(this);
			this.validaRejeicaoOrgaoFornecedor = this.validaRejeicaoOrgaoFornecedor.bind(this);
			this.validaRejeicaoOrgaoAdministrador = this.validaRejeicaoOrgaoAdministrador.bind(this);
			this.validaEsferaAdministrativa = this.validaEsferaAdministrativa.bind(this);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;

			api.get(`/api/solicitacao-adesao-arquivo-gv/${id}`)
				.then(response => { 
					const solicitacao = response.data;
					this.setState({ solicitacao }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar a solicitação de adesão a arquivos de grandes volumes.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				});
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Adesão a Arquivos de Grandes Volumes</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		renderForm() {
			const user = this.props.user;
			const solicitacao = this.state.solicitacao;

			return(
				<div className="container-fluid">
					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalConfirmacao}
						handleOk={() => this.executaOperacao()}
						handleCancel={() => this.fechaModal()}
						message={this.state.msgModal}/>

					<SolicitacaoAdesaoArquivosGrandesVolumesDetails solicitacao={solicitacao} mostraDetalhesAprovacao={false}/>
					

					<div className="br-form">
						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="justificativaOrgaoFornecedor">Justificativa cedente dos dados:</label>
										<textarea name="justificativaOrgaoFornecedor" value={solicitacao.justificativaOrgaoFornecedor} 
											onChange={this.handleInputChange} maxLength={500} style={{height:"90px"}}
											readOnly={! solicitacao.aprovacaoFornecedoraPermitida}/>
									</div>
								</div>
							</div>

							{user.isAdministrador && 
								<Fragment>
									<div className="col-md">  
										<div className="field">
											<div className="input"> 
												<label htmlFor="justificativaOrgaoAdministrador">Justificativa conecta:</label>
												<textarea name="justificativaOrgaoAdministrador" value={solicitacao.justificativaOrgaoAdministrador} 
												onChange={this.handleInputChange} maxLength={500} style={{height:"90px"}}
												readOnly={! solicitacao.aprovacaoAdministradorPermitida}/>
											</div>
										</div>
									</div>
								</Fragment>
							}
						</div> 

						<SolicitacaoAdesaoAttachmentsAndHistory solicitacao={solicitacao} habilitaEdicaoAnexo={true}/>

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
								{solicitacao.aprovacaoFornecedoraPermitida && 
									<Fragment>
										<button type="button" className="button is-primary" onClick={() => this.confirmaOperacao(this.aprovarSolicitacao, "Deseja realmente APROVAR a solicitação de adesão?")}  disabled={!this.state.botoesHabilitados}>Aprovar</button>
										<button type="button" className="button is-secondary" onClick={() => this.confirmaOperacao(this.rejeitarSolicitacaoOrgaoFornecedor, "Deseja realmente REJEITAR a solicitação de adesão?", this.validaRejeicaoOrgaoFornecedor)}  disabled={!this.state.botoesHabilitados}>Rejeitar</button>
									</Fragment>
								}

								{solicitacao.aprovacaoAdministradorPermitida && 
									<Fragment>
										<button type="button" className="button is-primary" onClick={() => this.confirmaDeferimento(this.deferirSolicitacao, "Deseja realmente deferir a solicitação de adesão?")}  disabled={!this.state.botoesHabilitados}>Deferir</button>
									</Fragment>
								}

								{solicitacao.rejeicaoAdministradorPermitida && 
									<Fragment>
										<button type="button" className="button is-secondary" onClick={() => this.confirmaOperacao(this.rejeitarSolicitacaoAdministrador, "Deseja realmente rejeitar a solicitação de adesão?", this.validaRejeicaoOrgaoAdministrador)}  disabled={!this.state.botoesHabilitados}>Rejeitar</button>
									</Fragment>
								}

								<ButtonBack disabled={!this.state.botoesHabilitados} />								
							</div>
						</div>
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = valor;
			this.setState({ solicitacao });
		}

		async confirmaDeferimento(operacao, msgModal, validacao) {
			const esferaAdministrativaValida = await this.validaEsferaAdministrativa();
			let mensagem
			if(esferaAdministrativaValida){
				mensagem = msgModal
			} else {
				mensagem = `<b>Atenção</b>: O conjunto de arquivos ${this.state.solicitacao.tituloConjuntoArquivo} não está mais disponível para a esfera administrativa do órgão da solicitação.<br/> ${msgModal}`;
			}
			this.confirmaOperacao(operacao, mensagem, validacao);
		}
	
		confirmaOperacao(operacao, msgModal, validacao) {
			if(validacao) {
				try{
					validacao();
				}catch(erroValidacao){
					return;
				}
			}

			this.setState(
				{
					exibeModalConfirmacao: true,
					operacao,
					msgModal,
				}
			);
		}

		executaOperacao () {
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			this.state.operacao();
			this.fechaModal();
		}

		executaAndamento (url, mensagemSucesso, mensagemErro) {
			const { solicitacao } = this.state;
			const { id, justificativaOrgaoFornecedor, justificativaOrgaoAdministrador } = solicitacao;

			const options = {
				method: 'put',
				url,
				data: { id, justificativaOrgaoFornecedor, justificativaOrgaoAdministrador },
			}

			api(options)
				.then(response => { 
					this.setState({
						solicitacao: response.data,
						pesquisaExecutada : true,
					}) 
					this.props.exibeMensagemSucesso(mensagemSucesso);
				})
				.catch(erro => {
					const msg = getMessagemErro(mensagemErro, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

		validaRejeicaoOrgaoFornecedor(){
			const { solicitacao } = this.state;
			const { justificativaOrgaoFornecedor } = solicitacao;
			
			if(!justificativaOrgaoFornecedor || justificativaOrgaoFornecedor.trim().length === 0 ){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", [{mensagem: "Justificativa cedente dos dados é obrigatória."}])
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		validaRejeicaoOrgaoAdministrador(){
			const { solicitacao } = this.state;
			const { justificativaOrgaoAdministrador } = solicitacao;

			if(!justificativaOrgaoAdministrador || justificativaOrgaoAdministrador.trim().length === 0 ){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", [{mensagem: "Justificativa conecta é obrigatória."}])
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		async validaEsferaAdministrativa ( ) {
			const { solicitacao } = this.state;
			const { conjuntoArquivo, orgao } = solicitacao;

			try {
				const response = await api.get(`/api/conjunto-arquivo-gv/disponivel-esfera-administrativa-orgao/${conjuntoArquivo}/${orgao}`)
				return response.data;
			} catch (erro) {
				console.log(erro);
				throw new Error("Não foi possível validar a esfera administrativa do órgão da solicitação de adesão.");
			};
		}

		aprovarSolicitacao () {
			const mensagemSucesso = "Solicitação de adesão aprovada com sucesso.";
			const mensagemErro = "Não foi possível aprovar a solicitação de adesão.";
			const url = '/api/solicitacao-adesao-arquivo-gv/aprovar';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

		rejeitarSolicitacaoOrgaoFornecedor() {
			const mensagemSucesso = "Solicitação de adesão rejeitada com sucesso.";
			const mensagemErro = "Não foi possível rejeitar a solicitação de adesão.";
			const url = '/api/solicitacao-adesao-arquivo-gv/rejeitar-orgao-fornecedor';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

		deferirSolicitacao() {
			const mensagemSucesso = "Solicitação de adesão deferida com sucesso.";
			const mensagemErro = "Não foi possível deferir a solicitação de adesão.";
			const url = '/api/solicitacao-adesao-arquivo-gv/deferir';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

		rejeitarSolicitacaoAdministrador() {
			const mensagemSucesso = "Solicitação de adesão rejeitada com sucesso.";
			const mensagemErro = "Não foi possível rejeitar a solicitação de adesão.";
			const url = '/api/solicitacao-adesao-arquivo-gv/rejeitar-administrador';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

		fechaModal () {
			this.setState(
				{
					exibeModalConfirmacao: false,
				}
			);
		}
	}

) // redux
); // router